// import LabelWithInfoTooltip from "./Components/InfoToolTips";
// import withRestrictions from "../../Hoc/withRestrictions";
// import withLanguage from "../../Hoc/withLanguage";

// const DetailRow = ({
//   data,
//   label,
//   highlight,
//   enableEdit,
//   editFlag,
//   idField,
//   tooltipId,
//   tooltipInfo,
//   isBlured,
//   tooltip
// }) => {

//   const displayValue = data !== null && data !== undefined ? data : data === 0 ? 0 : "";

//   const shouldEnableEdit = enableEdit && displayValue !== '';

//   const className = [
//     displayValue === "-" ? "" : "counterDiv",
//     shouldEnableEdit ? "enableEdit" : "disableEdit",
//   ]
//     .filter(Boolean) // remove empty strings
//     .join(" ");
//     const borderStyle = isBlured ? '2px dotted #ff1515' : shouldEnableEdit ? '1px solid #ccc' : '';
//   return (
//     <>
//       {data !== null && data !== undefined && data !== "" && (
//         <>
//           <div>
//             {highlight ? (
//               <>
//                 <span className="fw-bold">{label}:</span>
//                 {tooltipId && tooltipInfo && (
//                   <LabelWithInfoTooltip info={tooltipInfo} id={tooltipId} />
//                 )}
//               </>
//             ) : (
//               <>
//                 <span className="fw-bold">{label}: </span>
//                 {tooltipId && tooltipInfo && (
//                   <LabelWithInfoTooltip info={tooltipInfo} id={tooltipId} />
//                 )}
//               </>
//             )}
//           </div>
//           <div
//             id={idField}
//             className={className}
//             style={{
//               whiteSpace: "pre-wrap",
//               wordBreak: "break-word",
//               border: borderStyle,
//             }}
//           >
//             {tooltip ? (
//               <LabelWithInfoTooltip info={tooltip} id={idField}>
//                 {data}
//                 <LabelWithInfoTooltip
//                   info={tooltip}
//                   id={idField}
//                   color={"#FFBCB3"}
//                 />
//               </LabelWithInfoTooltip>
//             ) : (
//               <>{data}</>
//             )}
//           </div>
//         </>
//       )}
//     </>
//   );
// };

// export default withRestrictions(withLanguage(DetailRow));
import LabelWithInfoTooltip from "./Components/InfoToolTips";
import withRestrictions from "../../Hoc/withRestrictions";
import withLanguage from "../../Hoc/withLanguage";
import { useMemo } from "react";
import MandatoryLabel from "./Components/MandatoryLabel";

const DetailRow = ({
  data,
  label,
  highlight,
  enableEdit,
  editFlag,
  idField,
  tooltipId,
  tooltipInfo,
  isBlured,
  tooltip,
  required,
}) => {
  // ✅ DISPLAY ONLY
  const displayValue = useMemo(() => {
    if (data === null || data === undefined || data === "" || data === 0) {
      return "-";
    }
    return data;
  }, [data]);

  // ✅ EDIT ONLY (raw data)
  const shouldEnableEdit =
    enableEdit && data !== null && data !== undefined && data !== "";

  const className = [
    displayValue !== "-" ? "counterDiv" : "",
    shouldEnableEdit ? "enableEdit" : "disableEdit",
  ]
    .filter(Boolean)
    .join(" ");

  const borderStyle = isBlured
    ? "2px dotted #ff1515"
    : shouldEnableEdit
    ? "1px solid #ccc"
    : "";

  // ❗ render only if meaningful data exists
  if (data === null || data === undefined || data === "") {
    return null;
  }

  return (
    <>
      <div>
        <MandatoryLabel
          label={label}
          required={required}
        />
        {tooltipId && tooltipInfo && (
          <LabelWithInfoTooltip info={tooltipInfo} id={tooltipId} />
        )}
      </div>

      <div
        key={`${idField}-${JSON.stringify(data)}`} // forces update on change
        id={idField}
        className={className}
        style={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          border: borderStyle,
        }}
      >
        {tooltip ? (
          <LabelWithInfoTooltip info={tooltip} id={idField}>
            {displayValue}
          </LabelWithInfoTooltip>
        ) : (
          displayValue
        )}
      </div>
    </>
  );
};

export default withRestrictions(withLanguage(DetailRow));
